import React, { useState} from 'react';
import { isAuthenticated } from "../../../../auth";
import { attachPaymentIntents } from '../../../walletApi'

import EnterAmount from './enterAmount'
import PaymentMethod from './paymentMethod'
import ConfirmDetails from './confirmDetails'
import Layout from "../../../../core/Layout";



const Paymongo = () =>{
    const { token } = isAuthenticated();
    const [steps, setSteps] = useState(0);
    const [clientKey, setClientKey] = useState('');
    const [paymentId, setPaymentMethodId] = useState('');
    const [attachIntents, setAttachIntents] = useState({});
    
    const dataHandler = (data) => {
        if(data.client_key !== undefined){
            setClientKey(data.client_key)
        }
        if(data.id){
            setPaymentMethodId(data.id)

        }

    }

    if(clientKey && paymentId){
        const data = {
            paymentMethodId:paymentId, 
            paymentintent_clientKey:clientKey, 
            return_url:"http://localhost:3000/react"
        }
        attachPaymentIntents(data, token).then((data =[]) =>{
            if (data && data.error) {
                console.log(data.error) 
            } else {
                if(data.data){
                    setAttachIntents(data.data)
                }
            }
          }) 
    }

    return(
        <Layout>
            {steps === 0 ? (
            <EnterAmount 
            dataHandler={(val) =>{setSteps(1); dataHandler(val);}}
            /> 
            ): steps === 1 ? (
                <PaymentMethod
                dataHandler={(val) =>{ setSteps(2);dataHandler(val)}}
                />
            ):(
                <ConfirmDetails attachIntents={attachIntents} />
            )
            }
        </Layout>
    );
}

export default Paymongo; 